type OwnProps = {
  id?: string;
  className?: string;
  children?: React.ReactNode;
};

const defaultProps: Partial<OwnProps> = {
  id: undefined,
  className: undefined,
  children: undefined,
};

type Props = OwnProps & typeof defaultProps;

function Breadcrumb({ id, className, children }: Props) {
  return (
    <nav
      role="navigation"
      aria-label="Breadcrumb"
      id={id}
      className={["breadcrumb", className].filter((c) => c).join(" ")}
    >
      {children}
    </nav>
  );
}

Breadcrumb.defaultProps = defaultProps;

export default Breadcrumb;
